/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WaitingListSortBy {
  DATE = 'date',
  CREATED_AT = 'created_at',
}
